// Tutoriels par espace utilisateur (dashboards)

export const TUTORIALS_DASHBOARDS = {
  member_dashboard: {
    id: 'member_dashboard',
    name: 'Découverte de votre espace membre',
    steps: [
      {
        targetId: 'welcome-section',
        title: '👋 Bienvenue sur votre espace !',
        content: 'Cet espace vous permet de gérer tous vos dispositifs solidaires, vos dommages, vos abonnements et vos fichiers. Suivez ce guide rapide pour découvrir les fonctionnalités principales.',
        position: 'bottom'
      },
      {
        targetId: 'subscription-card',
        title: '📦 Votre Abonnement',
        content: 'Consultez votre formule actuelle et les crédits disponibles. Vous pouvez upgrader à tout moment pour bénéficier de plus d\'avantages.',
        position: 'bottom'
      },
      {
        targetId: 'wallet-card',
        title: '💳 Votre Portefeuille',
        content: 'Suivez votre solde de crédits et achetez des packages pour accéder aux services premium à l\'unité.',
        position: 'bottom'
      },
      {
        targetId: 'simulateur-link',
        title: '🧮 Garantie RCDS-BATICO',
        content: 'Utilisez le simulateur Garantie RCDS BATICO pour évaluer votre contribution et découvrir les dispositifs adaptés à votre entreprise.',
        position: 'right'
      },
      {
        targetId: 'souscriptions-link',
        title: '📋 Vos Dispositifs',
        content: 'Accédez à tous vos dispositifs solidaires souscrits et suivez leur statut en temps réel.',
        position: 'right'
      },
      {
        targetId: 'dommages-link',
        title: '🔧 Déclaration Dommages',
        content: 'Déclarez un nouveau dommage et suivez l\'avancement de vos dossiers d\'expertise.',
        position: 'right'
      },
      {
        targetId: 'documents-link',
        title: '📁 Documents',
        content: 'Accédez à tous vos documents : contrats, attestations, factures et pièces justificatives.',
        position: 'right'
      },
      {
        targetId: 'videos-link',
        title: '🎬 Vidéos',
        content: 'Importez et gérez vos fichiers vidéos (MP4, WebM, AVI...). Taille max: 500 MB par vidéo.',
        position: 'right'
      },
      {
        targetId: 'messages-link',
        title: '💬 Messagerie',
        content: 'Communiquez directement avec les experts, conseillers et l\'équipe support.',
        position: 'right'
      },
      {
        targetId: 'bibliotheque-link',
        title: '📚 Bibliothèque',
        content: 'Accédez à tous les modèles de documents et attestations pour vos démarches.',
        position: 'right'
      }
    ]
  },

  // ==================== ESPACE ADMIN ====================
  admin_dashboard: {
    id: 'admin_dashboard',
    name: 'Découverte de l\'espace Admin',
    steps: [
      {
        targetId: 'welcome-admin',
        title: '👋 Bienvenue Administrateur !',
        content: 'Votre espace vous permet de gérer les membres, les souscriptions, les nomenclatures et tous les paramètres de la plateforme.',
        position: 'bottom'
      },
      {
        targetId: 'stats-overview',
        title: '📊 Tableau de Bord',
        content: 'Visualisez les statistiques clés : nombre de membres, souscriptions actives, dommages en cours.',
        position: 'bottom'
      },
      {
        targetId: 'membres-section',
        title: '👥 Gestion des Membres',
        content: 'Créez, modifiez et gérez les comptes membres. Assignez des experts et suivez les dossiers.',
        position: 'right'
      },
      {
        targetId: 'simulateurs-link',
        title: '🧮 Simulateurs',
        content: 'Gérez les simulateurs disponibles (BATICO, DOMIUM, etc.) et leurs configurations.',
        position: 'right'
      },
      {
        targetId: 'nomenclatures-link',
        title: '📋 Nomenclatures',
        content: 'Gérez les codes d\'activités, les catégories (Gros Œuvre, Second Œuvre, etc.) et les tarifications.',
        position: 'right'
      },
      {
        targetId: 'ged-link',
        title: '📁 GED (Documents)',
        content: 'Accédez à la Gestion Électronique des Documents pour tous les utilisateurs.',
        position: 'right'
      },
      {
        targetId: 'videos-link',
        title: '🎬 Vidéos',
        content: 'Gérez les fichiers vidéos de la plateforme. Importez des tutoriels, formations ou présentations.',
        position: 'right'
      },
      {
        targetId: 'messagerie-link',
        title: '💬 Messagerie',
        content: 'Communiquez avec les membres, experts et autres administrateurs.',
        position: 'right'
      },
      {
        targetId: 'validation-virements',
        title: '✅ Validation Virements',
        content: 'Validez les paiements par virement bancaire et générez les reçus ESS automatiquement.',
        position: 'right'
      }
    ]
  },

  // ==================== ESPACE SUPER ADMIN ====================
  superadmin_dashboard: {
    id: 'superadmin_dashboard',
    name: 'Découverte de l\'espace Super Admin',
    steps: [
      {
        targetId: 'welcome-superadmin',
        title: '👑 Bienvenue Super Administrateur !',
        content: 'Vous avez accès à toutes les fonctionnalités de la plateforme, y compris les configurations avancées.',
        position: 'bottom'
      },
      {
        targetId: 'configurations-simulateurs',
        title: '⚙️ Configurations Simulateurs',
        content: 'Créez et configurez les simulateurs (BATICO, DOMIUM, CCMI...). Définissez les coefficients, remises et restrictions.',
        position: 'bottom'
      },
      {
        targetId: 'parametres-batico',
        title: '📊 Paramètres BATICO',
        content: 'Configurez les paramètres du simulateur BATICO : contributions, taxes, coefficients RCD.',
        position: 'right'
      },
      {
        targetId: 'gestion-admins',
        title: '👥 Gestion des Admins',
        content: 'Créez et gérez les comptes administrateurs. Attribuez les rôles et permissions.',
        position: 'right'
      },
      {
        targetId: 'cms-link',
        title: '📝 CMS (Contenu)',
        content: 'Gérez le contenu des pages publiques : textes, images, FAQ, mentions légales.',
        position: 'right'
      },
      {
        targetId: 'modeles-documents',
        title: '📄 Modèles Documents',
        content: 'Créez et gérez les modèles de documents : contrats, attestations, reçus.',
        position: 'right'
      },
      {
        targetId: 'videos-link',
        title: '🎬 Vidéos',
        content: 'Gérez tous les fichiers vidéos de la plateforme. Formats supportés: MP4, WebM, AVI, MOV.',
        position: 'right'
      },
      {
        targetId: 'export-import',
        title: '📤 Export/Import Données',
        content: 'Exportez ou importez des données en masse (membres, souscriptions, nomenclatures).',
        position: 'right'
      },
      {
        targetId: 'alerts-link',
        title: '🔔 Alertes',
        content: 'Consultez les alertes système : contrats expirant, paiements en retard, etc.',
        position: 'right'
      }
    ]
  },

  // ==================== ESPACE COOPER'S ====================
  cooper_dashboard: {
    id: 'cooper_dashboard',
    name: 'Découverte de l\'espace COOPER\'S',
    steps: [
      {
        targetId: 'welcome-cooper',
        title: '👋 Bienvenue sur votre espace COOPER\'S !',
        content: 'Gérez vos adhérents, suivez les souscriptions et développez votre réseau de partenaires.',
        position: 'bottom'
      },
      {
        targetId: 'adherents-section',
        title: '👥 Mes Adhérents',
        content: 'Consultez la liste de vos adhérents et suivez l\'état de leurs souscriptions.',
        position: 'bottom'
      },
      {
        targetId: 'simulateur-link',
        title: '🧮 Garantie RCDS-BATICO',
        content: 'Utilisez le simulateur Garantie RCDS BATICO pour accompagner vos adhérents dans le choix de leur dispositif.',
        position: 'right'
      },
      {
        targetId: 'adhesions-link',
        title: '📋 Adhésions',
        content: 'Gérez les demandes d\'adhésion et validez les nouveaux membres.',
        position: 'right'
      },
      {
        targetId: 'documents-link',
        title: '📁 Documents',
        content: 'Accédez aux documents partagés avec vos adhérents.',
        position: 'right'
      },
      {
        targetId: 'videos-link',
        title: '🎬 Vidéos',
        content: 'Partagez des vidéos avec vos adhérents : tutoriels, formations, présentations.',
        position: 'right'
      },
      {
        targetId: 'messagerie-link',
        title: '💬 Messagerie',
        content: 'Communiquez directement avec vos adhérents et l\'équipe support.',
        position: 'right'
      },
      {
        targetId: 'conventions-link',
        title: '📝 Conventions',
        content: 'Gérez vos conventions de partenariat avec COPPAM.',
        position: 'right'
      },
      {
        targetId: 'tampons-link',
        title: '🔖 Mes Tampons',
        content: 'Créez et gérez vos tampons personnalisés pour signer les documents.',
        position: 'right'
      }
    ]
  },

  // ==================== ESPACE EXPERT ====================
  expert_dashboard: {
    id: 'expert_dashboard',
    name: 'Découverte de l\'espace Expert',
    steps: [
      {
        targetId: 'welcome-expert',
        title: '👋 Bienvenue Expert/Conseiller !',
        content: 'Votre espace vous permet de gérer les dossiers de dommages assignés et d\'accompagner les membres.',
        position: 'bottom'
      },
      {
        targetId: 'dossiers-section',
        title: '📋 Dossiers Assignés',
        content: 'Consultez les dossiers de dommages qui vous sont assignés et traitez-les par priorité.',
        position: 'bottom'
      },
      {
        targetId: 'simulateur-link',
        title: '🧮 Garantie RCDS-BATICO',
        content: 'Utilisez le simulateur Garantie RCDS BATICO pour accompagner les membres dans leurs simulations.',
        position: 'right'
      },
      {
        targetId: 'dommages-link',
        title: '🔧 Dommages',
        content: 'Gérez les déclarations de dommages : expertise, rapport, suivi.',
        position: 'right'
      },
      {
        targetId: 'modeles-link',
        title: '📄 Modèles Documents',
        content: 'Accédez aux modèles de rapports d\'expertise et documents professionnels.',
        position: 'right'
      },
      {
        targetId: 'videos-link',
        title: '🎬 Vidéos',
        content: 'Consultez les vidéos de formation et partagez vos propres contenus.',
        position: 'right'
      },
      {
        targetId: 'messagerie-link',
        title: '💬 Messagerie',
        content: 'Communiquez avec les membres pour le suivi de leurs dossiers.',
        position: 'right'
      },
      {
        targetId: 'signature-link',
        title: '✍️ Module Signature',
        content: 'Signez électroniquement les rapports et documents officiels.',
        position: 'right'
      },
      {
        targetId: 'profil-link',
        title: '👤 Mon Profil',
        content: 'Gérez votre profil professionnel : spécialisations, disponibilités, coordonnées.',
        position: 'right'
      }
    ]
  },
};
